import type { PbxSettingsLocale } from './en'

export const pbxSettingsNe = {
  loading: 'पीबीएक्स सेटिङहरू लोड हुँदैछ...',
  invalidPbx: {
    title: 'अवैध पीबीएक्स',
    description:
      'पीबीएक्स सेटिङहरू सम्पादन गर्न मान्य पीबीएक्स ID आवश्यक छ। कृपया ड्यासबोर्डबाट पीबीएक्स चयन गर्नुहोस्।',
  },
  loadError: {
    title: 'पीबीएक्स सेटिङहरू लोड गर्न सकिएन',
    description: 'कृपया फेरि प्रयास गर्नुहोस्।',
  },
  partialLoadWarning: {
    title: 'केही डेटा लोड हुन सकेन',
    unknownError: 'अज्ञात त्रुटि',
    labels: {
      providerGateways: 'प्रोभाइडर गेटवेहरू',
      serverGroups: 'सर्भर समूहहरू',
      phoneNumbers: 'फोन नम्बरहरू',
      virtualFaxes: 'भर्चुअल फ्याक्सहरू',
      alert911Options: '911 विकल्पहरू',
    },
  },
  actions: {
    update: 'अपडेट',
  },
  common: {
    loading: 'लोड हुँदैछ...',
    select: 'चयन गर्नुहोस्',
  },
  sections: {
    core: {
      title: 'पीबीएक्स सेटिङहरू',
    },
    advanced: {
      title: 'उन्नत पीबीएक्स सेटिङहरू',
    },
    system: {
      title: 'प्रणाली सेटिङहरू',
    },
  },
  placeholders: {
    selectFromList: 'सूचीबाट चयन गर्नुहोस्...',
    selectServerGroup: 'सर्भर समूह चयन गर्नुहोस्',
    selectTimeZone: 'समय क्षेत्र चयन गर्नुहोस्',
    selectExtensionDigits: 'एक्सटेन्सन अंक चयन गर्नुहोस्',
    selectCodec: 'कोडेक चयन गर्नुहोस्',
  },
  fields: {
    pbxDisplayName: {
      label: 'पीबीएक्स प्रदर्शन नाम',
    },
    company: {
      label: 'कम्पनी',
    },
    providerGateway: {
      label: 'प्रोभाइडर गेटवे',
    },
    emergencyProviderGateway: {
      label: 'आपतकालीन प्रोभाइडर गेटवे',
    },
    internationalProviderGateway: {
      label: 'अन्तर्राष्ट्रिय प्रोभाइडर गेटवे',
    },
    active: {
      label: 'सक्रिय',
    },
    smsSenderName: {
      label: 'एसएमएस प्रेषकको नाम',
      copyFromCompany: 'कम्पनीबाट कपी गर्नुहोस्',
      helperText:
        'एसएमएस ओप्ट-आउट जवाफहरूमा तपाईंका ग्राहकहरूलाई देखिन्छ, जस्तै "{{name}}: तपाईंले सफलतापूर्वक सदस्यता रद्द गर्नुभयो।" यो स्थान अनुसार हो — कम्पनीको नामभन्दा फरक छ भने यहाँ सम्पादन गर्नुहोस्।',
      divergenceHint:
        'कम्पनीको नाम "{{companyName}}" भन्दा फरक छ — बहु-स्थान ग्राहकहरूको लागि यो सामान्य हो।',
    },
    serverGroup: {
      label: 'सर्भर समूह',
    },
    advanced: {
      maximum_allowed_channels: 'अधिकतम च्यानल',
      maximum_lines_in: 'इनबाउन्ड च्यानल',
      maximum_lines_out: 'प्रति एक्सटेन्सन च्यानल',
      call_log_retention_period_in_months: 'कल इतिहास (महिनामा)',
    },
    industry: {
      label: 'उद्योग',
    },
    ehr: {
      label: 'EHR',
      helperText: 'प्रतिवेदन प्रयोजनका लागि मात्र, कार्यक्षमतामा असर गर्दैन',
    },
    defaultEmergencyAlert: {
      label: 'डिफल्ट आपतकालीन अलर्ट',
    },
    defaultTimeZone: {
      label: 'डिफल्ट समय क्षेत्र',
      britishColumbia: 'प्रशान्त समय - ब्रिटिश कोलम्बिया (PCT)',
    },
    callParkTimeout: {
      label: 'कल पार्क टाइमआउट',
    },
    extensionDigits: {
      label: 'एक्सटेन्सन अंक',
    },
    defaultAreaCode: {
      label: 'डिफल्ट क्षेत्र कोड',
    },
    defaultCallerId: {
      label: 'डिफल्ट कलर आईडी',
    },
    defaultFaxNumber: {
      label: 'डिफल्ट फ्याक्स नम्बर',
    },
    defaultVirtualFax: {
      label: 'डिफल्ट भर्चुअल फ्याक्स',
    },
    preferredCodec: {
      label: 'मनपर्ने कोडेक',
    },
    checkboxes: {
      enable_inbound_recording: 'इनबाउन्ड कल रेकर्डिङ',
      enable_outbound_recording: 'आउटबाउन्ड कल रेकर्डिङ',
      enable_internal_recording: 'आन्तरिक कल रेकर्डिङ',
      international: 'अन्तर्राष्ट्रिय',
      enable_vm_transcription: 'भ्वाइसमेल ट्रान्सक्रिप्सन',
      schedules_v2: 'तालिका V2',
      enable_agent_statuses: 'कल सेन्टर',
      enable_call_analytics: 'Mango AI',
      is_grove: 'Grove',
    },
  },
  companySelect: {
    placeholder: 'कम्पनी चयन गर्नुहोस्',
    ariaLabel: 'कम्पनी चयनकर्ता',
    searchPlaceholder: 'कम्पनी खोज्नुहोस्...',
    empty: {
      loading: 'कम्पनीहरू लोड हुँदैछन्...',
      noResults: 'कुनै कम्पनी भेटिएन',
      typeToSearch: 'कम्पनी खोज्न टाइप गर्नुहोस्',
    },
  },
  phoneSelect: {
    placeholder: 'सूचीबाट चयन गर्नुहोस्...',
    ariaLabel: 'फोन नम्बर चयनकर्ता',
    searchPlaceholder: 'फोन नम्बर खोज्नुहोस्...',
    empty: {
      loading: 'फोन नम्बरहरू लोड हुँदैछन्...',
      noResults: 'कुनै फोन नम्बर भेटिएन',
      noData: 'उपलब्ध फोन नम्बरहरू छैनन्',
    },
  },
  toast: {
    validationError: 'मान्यकरण त्रुटि',
    timezoneChanged: {
      title: 'समय क्षेत्र परिवर्तन भयो',
      description:
        'तपाईंले पीबीएक्स समय क्षेत्र परिवर्तन गर्नुभयो। कृपया आफ्नो तालिकाहरू पनि अपडेट गर्नुहोस्।',
    },
    noChanges: 'सेभ गर्न कुनै परिवर्तन छैन',
    saveSuccess: 'पीबीएक्स सेटिङहरू अपडेट भयो',
    saveError: {
      title: 'अपडेट असफल भयो',
      description: 'पीबीएक्स सेटिङहरू अपडेट गर्दा समस्या आयो।',
    },
  },
  callParkConfirm: {
    title: 'कल पार्क टाइमआउट पुष्टि गर्नुहोस्',
    description:
      'के तपाईं कलरहरूलाई १० मिनेटभन्दा बढी पार्किङ लटमा राख्न चाहनुहुन्छ?',
    cancel: 'टाइमआउट रिसेट गर्नुहोस्',
    confirm: 'जारी राख्नुहोस्',
  },
  rebuildAndReboot: {
    title: 'पीबीएक्स सेटिङहरू अपडेट भयो',
    description:
      'केही पीबीएक्स सेटिङहरू यन्त्रहरू पुनर्निर्माण र पुनः सुरु नभएसम्म लागू नहुन सक्छन्।',
    cancel: 'अहिले होइन',
    confirm: 'यन्त्रहरू पुनर्निर्माण र पुनः सुरु गर्नुहोस्',
    toast: {
      successTitle: 'पुनर्निर्माण र पुनः सुरु सुरु भयो',
      successDescription: 'सबै यन्त्रहरू पुनर्निर्माण र पुनः सुरु हुँदैछन्।',
      errorTitle: 'पुनर्निर्माण र पुनः सुरु असफल भयो',
      errorDescription: 'यन्त्रहरू पुनर्निर्माण र पुनः सुरु गर्दा समस्या आयो।',
    },
  },
  validation: {
    pbxDisplayNameRequired: 'कृपया पीबीएक्स प्रदर्शन नाम प्रविष्ट गर्नुहोस्।',
    companyRequired: 'कृपया कम्पनी चयन गर्नुहोस्।',
    smsSenderNameRequired: 'कृपया एसएमएस प्रेषकको नाम प्रविष्ट गर्नुहोस्।',
    serverGroupRequired: 'कृपया सर्भर समूह चयन गर्नुहोस्।',
    primaryOutboundGatewayRequired:
      'कृपया प्राथमिक आउटबाउन्ड गेटवे चयन गर्नुहोस्।',
    primaryInternationalGatewayRequired:
      'कृपया प्राथमिक अन्तर्राष्ट्रिय गेटवे चयन गर्नुहोस्।',
    emergencyGatewayRequired: 'कृपया आपतकालीन गेटवे चयन गर्नुहोस्।',
    industryRequired: 'कृपया उद्योग चयन गर्नुहोस्।',
    maxChannelsRequired: 'कृपया अधिकतम च्यानल प्रविष्ट गर्नुहोस्।',
    inboundChannelsRequired: 'कृपया इनबाउन्ड च्यानल प्रविष्ट गर्नुहोस्।',
    perExtensionChannelsRequired:
      'कृपया प्रति एक्सटेन्सन च्यानल प्रविष्ट गर्नुहोस्।',
    callHistoryRequired: 'कृपया कल इतिहास प्रविष्ट गर्नुहोस्।',
    numericFieldRange: '{{field}} {{min}} र {{max}} बीचमा हुनुपर्छ।',
    numericFieldMin: 'न्यूनतम {{min}} हो।',
    numericFieldMax: 'अधिकतम {{max}} हो।',
    defaultTimeZoneRequired: 'कृपया डिफल्ट समय क्षेत्र चयन गर्नुहोस्।',
    callParkTimeoutRange:
      'कृपया कल पार्क टाइमआउट {{min}}-{{max}} बीचमा प्रविष्ट गर्नुहोस् (सिफारिस: {{recommended}})।',
    callParkTimeoutMax: 'कल पार्क टाइमआउट {{max}} सेकेन्डभन्दा बढी हुन सक्दैन।',
    extensionDigitsRequired: 'कृपया एक्सटेन्सन अंक प्रविष्ट गर्नुहोस्।',
    extensionDigitsInvalid: 'एक्सटेन्सन अंक 3, 4, वा 5 हुनुपर्छ।',
    defaultAreaCodeRequired: 'कृपया डिफल्ट क्षेत्र कोड प्रविष्ट गर्नुहोस्।',
    defaultAreaCodeDigits: 'डिफल्ट क्षेत्र कोड 3-अंकीय नम्बर हुनुपर्छ।',
    defaultAreaCodeRange: 'डिफल्ट क्षेत्र कोड 200 र 998 बीचमा हुनुपर्छ।',
    defaultAreaCodeDisallowed:
      'क्षेत्र कोड {{code}} डिफल्ट क्षेत्र कोडका लागि अनुमति छैन।',
    defaultCallerIdRequired: 'कृपया डिफल्ट कलर आईडी चयन गर्नुहोस्।',
    defaultFaxNumberRequired: 'कृपया डिफल्ट फ्याक्स नम्बर चयन गर्नुहोस्।',
    defaultVirtualFaxRequired: 'कृपया डिफल्ट भर्चुअल फ्याक्स चयन गर्नुहोस्।',
    preferredCodecRequired: 'कृपया मनपर्ने कोडेक चयन गर्नुहोस्।',
  },
} satisfies PbxSettingsLocale
